import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  organizations: "Organization.Organizations",
  list: "Organization.OrganizationList",
  new: "Organization.OrganizationNew",
  base: "Organization.OrganizationBase",
  view: "Organization.OrganizationView",
  edit: "Organization.OrganizationEdit",
  affiliations: "Organization.OrganizationAffiliations",
  affiliationEdit: "Organization.OrganizationAffiliationEdit",
  affiliationNew: "Organization.OrganizationAffiliationNew",
  recyclingReports: "Organization.OrganizationRecyclingReports",
  users: "Organization.OrganizationUsers",
  userNew: "Organization.OrganizationUserNew",
  audit: "Organization.OrganizationAudit",
};

export { names as organizationRouteNames };

const organizationRoutes: RouterOptions["routes"] = [
  {
    path: "/organizations",
    name: names.organizations,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Organizations", lookupGroups: ["RecyclingCategory"] },
        component: () => import("@/views/organization/OrganizationList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Organization", isNew: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: "OrganizationView" },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Organization View" },
            component: () => import("@/views/organization/OrganizationView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Organization Edit", isForm: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
          {
            path: "affiliations",
            name: names.affiliations,
            meta: { title: "Facility Site Affiliations" },
            component: () => import("@/views/organization/OrganizationAffiliations.vue"),
          },
          {
            path: "affiliations/:affiliationId(\\d+)/:entityType(person)",
            name: names.affiliationEdit,
            meta: { title: "Edit Facility Site Affiliation", isForm: true },
            component: () => import("@/views/organization/OrganizationAffiliation.vue"),
          },
          {
            path: "affiliations/new",
            name: names.affiliationNew,
            meta: { title: "Create Facility Site Affiliation", isForm: true },
            component: () => import("@/views/organization/OrganizationAffiliation.vue"),
          },
          {
            path: "recyclingReports",
            name: names.recyclingReports,
            meta: { title: "Organization Recycling Reports" },
            component: () => import("@/views/organization/RecyclingReportChildList.vue"),
          },
          {
            path: "users",
            name: names.users,
            meta: { title: "Organization Users" },
            component: () => import("@/views/organization/OrganizationUsers.vue"),
          },
          {
            path: "users/new",
            name: names.userNew,
            meta: { title: "Add Organization User", isForm: true },
            component: () => import("@/views/organization/OrganizationUser.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Organization Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Organization" />,
            },
          },
          // {
          //   path: "documents",
          //   name: "OrganizationDocuments",
          //   meta: { title: "Organization Documents" },
          //   component: { render: () => <div>docs</div> },
          // },
        ],
      },
    ],
  },
];
export default organizationRoutes;
